/*
* アンカーリンク（ページ内）
*/
const anchorLink = function() {

	const links = document.querySelectorAll('a[href*="#"]:not(.js-modal)');

	links.forEach(link => {
		link.addEventListener('click', e => {

			const href = link.getAttribute('href');
			if (!href) return;

			let url;
			try {
				url = new URL(href, location.href);
			} catch {
				return;
			}

			// 同一ページ内アンカーのみ
			if (url.pathname === location.pathname) {
				e.preventDefault();

				let target;
				if (url.hash === '#' || url.hash === '') {
					target = document.documentElement;
				} else {
					target = document.querySelector(url.hash);
				}

				if (!target) target = document.documentElement;
				anchorScroll(target);
			}
		});
	});
};


/*
* アンカーリンク（ページ遷移時）
*/
const anchorLinkUrlHash = function() {

	const urlHash = location.hash.replace('#', '');
	if (!urlHash) return;

	const scrollToTarget = () => {
		const target = document.getElementById(urlHash);
		if (target) {
			anchorScroll(target);
			history.replaceState(null, null, location.pathname);
		}
	};

	// 1回目：ロード完了時
	window.addEventListener('load', () => {
		scrollToTarget();
	});

	// 2回目：描画遅延対策
	setTimeout(scrollToTarget, 500);
};


/*
* アンカー時のスクロール
*/
const anchorScroll = function(target) {

	if (!target) return;

	const getHeaderHeight = () => {
		const header = document.querySelector('header');
		return header ? header.offsetHeight : 0;
	};

	const headerHeight = getHeaderHeight();
	let position = target.getBoundingClientRect().top + window.pageYOffset - headerHeight;

	animateScroll(position, 500, () => {

		// 再計算して微調整
		setTimeout(() => {

			const newHeaderHeight = getHeaderHeight();
			let newPosition = target.getBoundingClientRect().top + window.pageYOffset - newHeaderHeight;

			const diff = Math.abs(window.pageYOffset - newPosition);

			if (diff > 10) {
				animateScroll(newPosition, 300);
			}

		}, 100);
	});
};


/*
* scroll animation（jQuery swing 相当）
*/
const animateScroll = function(targetY, duration, callback) {

	const startY = window.pageYOffset;
	const diff = targetY - startY;
	const startTime = performance.now();

	const easeOutSwing = t => 0.5 - Math.cos(t * Math.PI) / 2;

	const step = now => {
		const elapsed = now - startTime;
		const progress = Math.min(elapsed / duration, 1);
		const eased = easeOutSwing(progress);

		window.scrollTo(0, startY + diff * eased);

		if (progress < 1) {
			requestAnimationFrame(step);
		} else if (typeof callback === 'function') {
			callback();
		}
	};

	requestAnimationFrame(step);
};


/*
* on load
*/
window.addEventListener('load', () => {
	anchorLink();
	anchorLinkUrlHash();
});
